import { useTranslation } from 'react-i18next';
import { formatPrice, type Locale } from '@rozman/shared';
import type { JSX } from 'react';

/**
 * Prices stay in PLN in both locales — a Ukrainian-speaking customer in Poland pays in
 * złoty. Only the number formatting is localised.
 */
export function Price({
  minor,
  className,
  from = false,
}: {
  minor: number | null;
  className?: string;
  from?: boolean;
}): JSX.Element {
  const { i18n, t } = useTranslation();
  const locale = i18n.language as Locale;
  if (minor === null) return <span className={className}>—</span>;
  return (
    <span className={className}>
      {from && <span className="text-[var(--color-muted)] font-normal">{t('common.from')} </span>}
      {formatPrice(minor, locale)}
    </span>
  );
}
